import { ExceptionType } from '../models';

const ExceptionConstant: { [key in ExceptionType]: string } = {
  [ExceptionType.AVAILABLE]: 'posManager.available',
  [ExceptionType.UNAVAILABLE]: 'posManager.unavailable'
};

export { ExceptionConstant };
